/* Product page behaviour: gallery, lightbox, pack selector, variant swap, sticky bar.
   Plain JS, deferred. theme.js owns add to cart and the quantity stepper clicks. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  const initGallery = (root) => {
    const g = $('[data-gallery]', root);
    if (!g || g.dataset.ready) return;
    g.dataset.ready = '1';
    const track = $('[data-gallery-track]', g);
    const slides = $$('[data-slide]', g);
    const thumbs = $$('[data-thumb]', g);
    const dots = $$('[data-dot]', g);
    const counter = $('[data-gallery-current]', g);
    let index = 0;
    let moved = Date.now();

    const mark = (i) => {
      index = i;
      moved = Date.now();
      thumbs.forEach((t, n) => (n === i ? t.setAttribute('aria-current', 'true') : t.removeAttribute('aria-current')));
      const strip = thumbs[i]?.closest('.pg__thumbs');
      if (strip) strip.scrollTo({ left: thumbs[i].offsetLeft - (strip.clientWidth - thumbs[i].offsetWidth) / 2, behavior: 'smooth' });
      dots.forEach((d, n) => (n === i ? d.setAttribute('aria-current', 'true') : d.removeAttribute('aria-current')));
      if (counter) counter.textContent = i + 1;
    };
    const go = (i) => {
      const n = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[n].offsetLeft - track.offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      mark(n);
    };
    g.goTo = go;

    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const n = Math.round(track.scrollLeft / track.clientWidth);
        if (n !== index && n >= 0 && n < slides.length) mark(n);
      });
    }, { passive: true });
    thumbs.forEach((t) => t.addEventListener('click', () => go(+t.dataset.thumb)));
    dots.forEach((d) => d.addEventListener('click', () => go(+d.dataset.dot)));
    const len = slides.length;
    $$('[data-gallery-prev]', g).forEach((b) => b.addEventListener('click', () => go((index - 1 + len) % len)));
    $$('[data-gallery-next]', g).forEach((b) => b.addEventListener('click', () => go((index + 1) % len)));
    // autoplay: next slide 6 s after the last move; holds while the pointer or keyboard focus is in the gallery, the lightbox
    // is open or the tab is hidden; off for reduced motion
    if (len > 1 && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      let hover = false;
      let key = false;
      g.addEventListener('pointerenter', () => { hover = true; });
      g.addEventListener('pointerleave', () => { hover = false; moved = Date.now(); });
      g.addEventListener('focusin', (e) => { key = e.target.matches(':focus-visible'); }); // keyboard focus only
      g.addEventListener('focusout', () => { key = false; moved = Date.now(); });
      setInterval(() => {
        if (hover || key || document.hidden || $('[data-lightbox]', g)?.open || Date.now() - moved < 6000) return;
        go((index + 1) % len);
      }, 500);
    }
    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
    });

    const box = $('[data-lightbox]', g);
    if (!box) return;
    const lbTrack = $('[data-lightbox-track]', box);
    const zoomable = slides.map((s, n) => (s.dataset.zoom ? n : -1)).filter((n) => n >= 0);
    const lbGo = (pos, smooth) => { lbAt = pos; lbTrack.scrollTo({ left: pos * lbTrack.clientWidth, behavior: smooth ? 'smooth' : 'auto' }); };
    let lbAt = 0; // kept on scroll: a closed dialog has no width to measure
    lbTrack.addEventListener('scroll', () => { if (lbTrack.clientWidth) lbAt = Math.round(lbTrack.scrollLeft / lbTrack.clientWidth); }, { passive: true });
    const lbPos = () => lbAt;
    const step = (d) => lbGo((lbPos() + d + zoomable.length) % zoomable.length, true);
    $$('[data-zoom-open]', g).forEach((b) => b.addEventListener('click', () => {
      if (!lbTrack.children.length) {
        lbTrack.innerHTML = zoomable.map((n) => `<li><img src="${slides[n].dataset.zoom}" alt="" loading="lazy" decoding="async"></li>`).join('');
        zoomable.forEach((n, i) => { lbTrack.children[i].firstChild.alt = $('img', slides[n])?.alt || ''; });
      }
      box.showModal();
      lbGo(Math.max(0, zoomable.indexOf(+b.dataset.zoomOpen)), false);
    }));
    $('[data-lightbox-close]', box).addEventListener('click', () => box.close());
    $('[data-lightbox-prev]', box).addEventListener('click', () => step(-1));
    $('[data-lightbox-next]', box).addEventListener('click', () => step(1));
    // a tap outside the image closes, like the backdrop did
    box.addEventListener('click', (e) => { if (e.target === box || e.target.parentElement === lbTrack) box.close(); });
    box.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') step(1);
      if (e.key === 'ArrowLeft') step(-1);
    });
    // leave the page gallery on the image that was open
    box.addEventListener('close', () => go(zoomable[lbPos()] ?? index));
  };

  // next business day in the warehouse time zone, weekend aware; rendered here so cached pages stay right
  const shipsBy = () => {
    $$('[data-ships-tz]').forEach((list) => {
      const out = $('[data-ships-by]', list);
      if (!out) return;
      const tz = list.dataset.shipsTz;
      const day = (d) => new Intl.DateTimeFormat('en-GB', { weekday: 'long', timeZone: tz }).format(d);
      const dow = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      let next = new Date(Date.now() + 864e5);
      for (let i = 0; i < 3 && ['Saturday', 'Sunday'].includes(day(next)); i++) next = new Date(next.getTime() + 864e5);
      // the weekday logic stays in English, the shown text is in the page language
      const lang = document.documentElement.lang || 'en';
      const tomorrow = day(new Date(Date.now() + 864e5)) === day(next);
      out.textContent = tomorrow
        ? new Intl.RelativeTimeFormat(lang, { numeric: 'auto' }).format(1, 'day')
        : new Intl.DateTimeFormat(lang, { weekday: 'long', timeZone: tz }).format(next);
    });
  };

  // money in the shop format: data-money is 1000.00 printed by Liquid (for example "€1.000,00")
  const money = (box, c) => {
    const [, th, dec] = box.dataset.money.match(/1(\D?)000(\D)00/) || [0, ',', '.'];
    const [int, frac] = (c / 100).toFixed(2).split('.');
    return box.dataset.money.replace(/1\D?000\D00/, int.replace(/\B(?=(\d{3})+$)/g, th) + dec + frac);
  };

  // pack rows and the quantity box both set the form quantity; the price follows the store's quantity discounts
  const setQty = (root, n) => {
    const box = $('[data-sync="tiers"]', root);
    if (!box) return;
    n = Math.min(99, Math.max(1, parseInt(n, 10) || 1));
    const breakPct = (q) => box.dataset.breaks.split(',').filter(Boolean).map((b) => b.split(':').map(Number))
      .reduce((p, [m, d]) => (q >= m ? d : p), 0);
    const pct = breakPct(n);
    const full = +box.dataset.unit * n;
    const sub = plan(root, n);
    // the plan discount comes first, the store's quantity discount then applies to the plan price (needs the quantity discounts set to apply on subscriptions)
    const price = (f, p) => Math.round((Math.round((f * (100 - (sub ? sub.pct : 0))) / 100) * (100 - p)) / 100);
    const cents = price(full, pct);
    // floor: never show more off than the customer gets
    const off = Math.floor(100 - (cents * 100) / full);
    $('[data-tier-qty]', box).value = n;
    $$('[data-tier]', box).forEach((r) => (r.checked = +r.value === n));
    $('[data-tier-qty-price]', box).innerHTML = `<strong>${money(box, cents)}</strong>${off ? ` <em>-${off}%</em>` : ''}`;
    $$('[data-tier]', box).forEach((r) => {
      const q = +r.value;
      const tf = +box.dataset.unit * q;
      const tc = price(tf, breakPct(q));
      const to = Math.floor(100 - (tc * 100) / tf);
      const day = $('.tier__day[data-days]', r.closest('.tier'));
      if (day) day.innerHTML = box.dataset.perDay.replace('__A__', money(box, Math.round(tc / +day.dataset.days)));
      $('.tier__price', r.closest('.tier')).innerHTML = `<span class="tier__total">${money(box, tc)}</span>${to ? `<span class="tier__was"><s>${money(box, tf)}</s><span class="tier__pct">-${to}%</span></span>` : ''}`;
    });
    const qty = $('[data-quantity]', root);
    if (qty) qty.value = n;
    const btn = $('[data-atc-label]', root);
    const label = btn && $('.btn__label', btn);
    if (label) label.textContent = `${btn.dataset.atcLabel} – ${money(box, cents)}`;
    freeShip(root, cents, box);
  };

  // one-time or subscription: the chosen selling plan goes into the form, empty for a one-time purchase
  const plan = (root, n) => {
    const input = $('[data-selling-plan]', root);
    const on = $('[data-sub-choice]:checked', root)?.value === 'sub';
    const opt = $('[data-sub-plan]:checked', root) || $('[data-sub-plan]', root);
    if (input) input.value = on && opt ? opt.value : '';
    const pct = +opt?.dataset.pct || 0;
    const flag = $('[data-sub-flag]', root);
    if (flag) flag.textContent = pct ? flag.dataset.tpl.replace('__P__', pct) : '';
    const note = $('[data-sub-note]', root);
    if (note && opt) note.textContent = note.dataset.tpl.replace('__Q__', n).replace('__F__', opt.dataset.freq.charAt(0).toLowerCase() + opt.dataset.freq.slice(1));
    return on && opt ? { id: opt.value, pct } : null;
  };

  // free shipping bar: cart total plus the chosen amount against the threshold
  // shortcut: the cart total is read at page load, so an add to cart on this page is not counted until reload
  const freeShip = (root, cents, box) => {
    const bar = $('[data-fship]', root);
    if (!bar) return;
    const goal = +bar.dataset.threshold;
    const have = +bar.dataset.cart + cents;
    const left = goal - have;
    const text = $('[data-fship-text]', bar);
    bar.classList.toggle('is-done', left <= 0);
    $('[data-fship-bar]', bar).style.width = `${Math.min(100, (have / goal) * 100)}%`;
    if (left <= 0) text.textContent = bar.dataset.done;
    else text.innerHTML = bar.dataset.away.replace('__A__', `<strong>${money(box, left)}</strong>`);
  };
  const tierQty = (root) => $('[data-tier-qty]', root)?.value;

  const initBuy = (root) => {
    if (root.dataset.buyReady) return;
    root.dataset.buyReady = '1';
    root.addEventListener('change', (e) => {
      if (e.target.matches('[data-variant-select]')) swapVariant(root, e.target.value);
      if (e.target.matches('[data-tier], [data-tier-qty]')) setQty(root, e.target.value);
      if (e.target.matches('[data-sub-choice], [data-sub-plan]')) setQty(root, tierQty(root));
    });
    root.addEventListener('click', (e) => {
      const step = e.target.closest('[data-tier-step]');
      if (step) setQty(root, +tierQty(root) + +step.dataset.tierStep);
    });
  };

  const swapVariant = async (root, id) => {
    const url = `${root.dataset.productUrl}?variant=${id}&section_id=${root.dataset.sectionId}`;
    try {
      const html = await (await fetch(url)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const n = tierQty(root);
      ['price', 'tiers', 'atc', 'sticky'].forEach((name) => {
        const fresh = $(`[data-sync="${name}"]`, doc);
        const old = $(`[data-sync="${name}"]`);
        if (fresh && old) old.replaceWith(fresh);
      });
      setQty(root, n);
      history.replaceState(null, '', `${root.dataset.productUrl}?variant=${id}`);
      shipsBy();
      initSticky(root);
      window.Shopify?.PaymentButton?.init();
    } catch (_) { /* keep the current state, the form still posts the chosen variant */ }
  };

  let stickyOff;
  const initSticky = (root) => {
    const bar = $('[data-sticky]');
    const main = $('[data-atc-main]', root);
    stickyOff?.();
    if (!bar || !main) return;
    const footer = $('.shopify-section-group-footer-group, footer');
    let raf;
    const paint = () => {
      const on = main.getBoundingClientRect().bottom < 0 && !(footer && footer.getBoundingClientRect().top < innerHeight);
      bar.hidden = false;
      bar.classList.toggle('is-visible', on);
      bar.toggleAttribute('inert', !on);
    };
    const onScroll = () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(paint); };
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', onScroll);
    stickyOff = () => { removeEventListener('scroll', onScroll); removeEventListener('resize', onScroll); };
    paint();
  };

  const init = () => {
    const root = $('[data-product-root]');
    if (!root) return;
    initGallery(root);
    initBuy(root);
    setQty(root, tierQty(root));
    shipsBy();
    initSticky(root);
  };

  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState !== 'loading') init();
  document.addEventListener('shopify:section:load', init);
})();
